// The mapping object contains all the locales that moment does not contain


const vNextMomentLocaleMappings = {
  'zh-SG': 'zh-CN'
};
const getLocale = (locale) => {
  if (!locale) return 'en';
  return vNextMomentLocaleMappings[locale] || locale;
};

export default getLocale;
